import React from 'react';
const SwichPaymentConfigurationConfig = {
    settings: {
        layout: {}
    },
    routes: [
        {
            path: '/apps/swich-payment-configuration',
            component: React.lazy(() => import('./SwichPaymentConfiguration'))
        }
    ]
};

export default SwichPaymentConfigurationConfig;
